import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { View, Text, Image, Pressable, StyleSheet } from 'react-native';
import { Button } from '../../Button/rn';
import { useLocale } from '../../LocaleProvider/rn'; // import { useComponentTracking } from '../../../hooks/useTracking';

import { ITEMS_TEXT, ITEM_TEXT,
//   ORDER_ID_TRANSIFY_KEY,
TOTAL_PAYMENT_TEXT, SELECT_ORDER_TEXT, LABEL_ORDER_TIME } from '../../../utils/constants';
import * as RNStyle from '../../../styles/rn';
import { FONT_WEIGHT_MEDIUM } from '../../../styles/rn'; // import { CustomStyleSheet } from '../../../utils/tools';

import { cdnFile } from '@mkt-common/shopee-common';
import UserAvatar from '../../../assets/images/default-user-avatar.png';
import { QuantitySelector } from '../../QuantitySelector/rn';
export var ProductCardNew = function ProductCardNew(props) {
  var title = props.title,
    itemCount = props.itemCount,
    totalPrice = props.totalPrice,
    orderSn = props.orderSn,
    handleOrderDetailRedirect = props.handleOrderDetailRedirect,
    orderStatusText = props.orderStatusText,
    image = props.image,
    onButtonClick = props.onButtonClick,
    selectOrderText = props.selectOrderText,
    totalPaymentText = props.totalPaymentText,
    itemText = props.itemText,
    itemsText = props.itemsText,
    orderTime = props.orderTime,
    orderTimeText = props.orderTimeText,
    index = props.index,
    watchFn = props.watchFn,
    buyerAvatar = props.buyerAvatar,
    _props$isMessageStyle = props.isMessageStyle,
    isMessageStyle = _props$isMessageStyle === void 0 ? false : _props$isMessageStyle,
    _props$isOrderSelect = props.isOrderSelect,
    isOrderSelect = _props$isOrderSelect === void 0 ? false : _props$isOrderSelect,
    _props$isUIOptimisati = props.isUIOptimisation,
    isUIOptimisation = _props$isUIOptimisati === void 0 ? false : _props$isUIOptimisati,
    _props$hasQuantitySel = props.hasQuantitySelector,
    hasQuantitySelector = _props$hasQuantitySel === void 0 ? false : _props$hasQuantitySel,
    _props$isRRStyle = props.isRRStyle,
    isRRStyle = _props$isRRStyle === void 0 ? false : _props$isRRStyle,
    _props$isRRHistorySty = props.isRRHistoryStyle,
    isRRHistoryStyle = _props$isRRHistorySty === void 0 ? false : _props$isRRHistorySty,
    _props$productID = props.productID,
    productID = _props$productID === void 0 ? '' : _props$productID,
    _props$stock = props.stock,
    stock = _props$stock === void 0 ? 0 : _props$stock,
    _props$stockText = props.stockText,
    stockText = _props$stockText === void 0 ? '' : _props$stockText,
    _props$productIDText = props.productIDText,
    productIDText = _props$productIDText === void 0 ? '' : _props$productIDText,
    _props$orderIDText = props.orderIDText,
    orderIDText = _props$orderIDText === void 0 ? '' : _props$orderIDText,
    _props$buyerName = props.buyerName,
    buyerName = _props$buyerName === void 0 ? '' : _props$buyerName,
    _props$orderSN = props.orderSN,
    orderSN = _props$orderSN === void 0 ? '' : _props$orderSN,
    _props$itemDescriptio = props.itemDescription,
    itemDescription = _props$itemDescriptio === void 0 ? '' : _props$itemDescriptio,
    handleQuantityChange = props.handleQuantityChange,
    _props$handleReduceDi = props.handleReduceDisable,
    handleReduceDisable = _props$handleReduceDi === void 0 ? function () {} : _props$handleReduceDi,
    _props$handleAddDisab = props.handleAddDisable,
    handleAddDisable = _props$handleAddDisab === void 0 ? function () {} : _props$handleAddDisab,
    _props$isLastQuantity = props.isLastQuantitySelector,
    isLastQuantitySelector = _props$isLastQuantity === void 0 ? false : _props$isLastQuantity,
    _props$affectedQtyTex = props.affectedQtyText,
    affectedQtyText = _props$affectedQtyTex === void 0 ? '' : _props$affectedQtyTex,
    _props$quantitySelect = props.quantitySelectorNumber,
    quantitySelectorNumber = _props$quantitySelect === void 0 ? 1 : _props$quantitySelect,
    _props$itemReturnable = props.itemReturnableCount,
    itemReturnableCount = _props$itemReturnable === void 0 ? 1 : _props$itemReturnable;
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  /**
   * TODO: Tracking
   */
  // const {
  //   tracker,
  //   result: { panelOrder: panelOrderTracking, panelOrderButton: panelOrderButtonTracking },
  // } = useComponentTracking({
  //   componentTrackingData,
  //   componentData: { ...props },
  // });

  var onClick = function onClick() {
    /**
     * TODO: Tracking
     */
    // 点击埋点
    // panelOrderButtonTracking?.trackingClick && tracker.click(panelOrderButtonTracking.trackingClick);
    onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick({
      data: props
    }, index);
  };
  var onOrderClick = function onOrderClick() {
    var _watchFn$collect;
    watchFn === null || watchFn === void 0 ? void 0 : (_watchFn$collect = watchFn.collect) === null || _watchFn$collect === void 0 ? void 0 : _watchFn$collect.call(watchFn, '[ProductCardNew] order click');
    /**
     * TODO: Tracking
     */
    // panelOrderTracking?.trackingClick && tracker.click(panelOrderTracking.trackingClick);

    handleOrderDetailRedirect === null || handleOrderDetailRedirect === void 0 ? void 0 : handleOrderDetailRedirect();
  };
  var onQuantitySelectorChange = function onQuantitySelectorChange(value) {
    handleQuantityChange === null || handleQuantityChange === void 0 ? void 0 : handleQuantityChange(value);
  };
  return /*#__PURE__*/React.createElement(Pressable, {
    style: [styles.product__container, isUIOptimisation && styles.productContainer],
    key: orderSn,
    onPress: onOrderClick // {...panelOrderTracking?.trackingImpressionProps}
    ,

    onLayout: function onLayout(e) {
      var _watchFn$collect2;
      var _e$nativeEvent$layout = e.nativeEvent.layout,
        width = _e$nativeEvent$layout.width,
        height = _e$nativeEvent$layout.height;
      watchFn === null || watchFn === void 0 ? void 0 : (_watchFn$collect2 = watchFn.collect) === null || _watchFn$collect2 === void 0 ? void 0 : _watchFn$collect2.call(watchFn, "[ProductCardNew] ProductCardNew render, width:".concat(width, " height:").concat(height));
    }
  }, isOrderSelect && /*#__PURE__*/React.createElement(View, {
    style: styles.productHeadTitle
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.productHeadLeftTitle
  }, buyerAvatar && (buyerAvatar === null || buyerAvatar === void 0 ? void 0 : buyerAvatar.length) > 0 ? /*#__PURE__*/React.createElement(Image, {
    style: styles.productHeadImg,
    source: {
      uri: buyerAvatar ? cdnFile(buyerAvatar) : ''
    }
  }) : /*#__PURE__*/React.createElement(Image, {
    style: styles.productHeadImg,
    source: UserAvatar
  }), /*#__PURE__*/React.createElement(Text, {
    style: styles.productHeadLeftText,
    numberOfLines: 1
  }, buyerName)), (orderIDText === null || orderIDText === void 0 ? void 0 : orderIDText.length) > 0 && /*#__PURE__*/React.createElement(Text, {
    style: styles.productHeadRightText,
    numberOfLines: 1
  }, orderIDText, ': ', orderSN)), !isUIOptimisation && /*#__PURE__*/React.createElement(View, {
    style: styles['product-order']
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles['product-order__time']
  }, orderTimeText || trans(LABEL_ORDER_TIME), ": ", orderTime)), /*#__PURE__*/React.createElement(View, {
    style: [styles['product-item'], isUIOptimisation && styles.productItem, isMessageStyle && styles.productItemWithoutBorder, isRRStyle && (hasQuantitySelector || isRRHistoryStyle) && styles.productItemWithCount]
  }, /*#__PURE__*/React.createElement(Image, {
    style: [styles['product-item-img'], isUIOptimisation && styles.productItemImg],
    source: {
      uri: isUIOptimisation ? cdnFile(image) : image
    }
  }), /*#__PURE__*/React.createElement(Text, {
    style: styles['product-item__title'],
    numberOfLines: 1
  }, title), !isRRStyle ? isUIOptimisation && !isOrderSelect ? /*#__PURE__*/React.createElement(View, {
    style: [styles.productItemSpec]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.productID],
    numberOfLines: 1
  }, (productIDText === null || productIDText === void 0 ? void 0 : productIDText.length) > 0 && /*#__PURE__*/React.createElement(Text, null, productIDText, ': ', productID)), (stockText === null || stockText === void 0 ? void 0 : stockText.length) > 0 && /*#__PURE__*/React.createElement(Text, {
    style: [styles.productStock],
    numberOfLines: 1
  }, stockText, ': ', stock)) : /*#__PURE__*/React.createElement(View, {
    style: [isUIOptimisation ? styles.productItemSpec : styles['product-item__spec']]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles['product-amount__count'], isUIOptimisation && styles.productID]
  }, itemCount, ' ', itemCount || Number(itemCount) > 1 ? itemsText || trans(ITEMS_TEXT) : itemText || trans(ITEM_TEXT), isUIOptimisation ? ', ' : ''), /*#__PURE__*/React.createElement(Text, {
    style: [isUIOptimisation && styles.productID]
  }, totalPaymentText || trans(TOTAL_PAYMENT_TEXT), ': ', /*#__PURE__*/React.createElement(Text, null, totalPrice))) : /*#__PURE__*/React.createElement(View, {
    style: styles.hasQuantitySelectoProductItem
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.hasQuantitySelectoProductItemText,
    numberOfLines: 1
  }, itemDescription), /*#__PURE__*/React.createElement(Text, {
    style: styles.hasQuantitySelectoProductItemText,
    numberOfLines: 1
  }, "x", itemCount)), /*#__PURE__*/React.createElement(View, {
    style: [{
      marginTop: 8,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }, isUIOptimisation && isMessageStyle && styles.selectFooter]
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    style: [styles['product-order__status'], isUIOptimisation && styles.productStatus]
  }, orderStatusText)), !isMessageStyle && /*#__PURE__*/React.createElement(Pressable, {
    style: styles['product-buttons'],
    onPress: function onPress(element) {
      return element.stopPropagation();
    } // {...panelOrderButtonTracking?.trackingImpressionProps}
  }, /*#__PURE__*/React.createElement(Button, {
    styles: {
      containerStyle: [styles['product-button'], isUIOptimisation && styles.productButton],
      textStyle: styles['product-button-text']
    },
    type: "primary",
    onClick: onClick,
    text: selectOrderText || trans(SELECT_ORDER_TEXT) // trackingData={componentTrackingData?.selectOrderButton}
    // componentData={{ content: selectOrderText || trans(SELECT_ORDER_TEXT) }}
  }))), hasQuantitySelector && /*#__PURE__*/React.createElement(View, {
    style: [styles.hasQuantitySelectoProductItem, styles.selectorWrapper, isLastQuantitySelector && styles.selectorWrapperWithoutBorderBottomWidth]
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.hasQuantitySelectoProductItemText,
    numberOfLines: 1
  }, affectedQtyText), /*#__PURE__*/React.createElement(QuantitySelector, {
    count: quantitySelectorNumber,
    maxCount: itemReturnableCount,
    minCount: 1,
    onChange: onQuantitySelectorChange,
    handleReduceDisable: handleReduceDisable,
    handleAddDisable: handleAddDisable
  }))));
};
var styles = StyleSheet.create({
  product__container: {
    paddingVertical: 0,
    paddingHorizontal: 12,
    backgroundColor: '#ffffff',
    marginTop: 8
  },
  productContainer: {
    marginTop: 0,
    paddingHorizontal: 12,
    paddingTop: 12,
    backgroundColor: '#ffffff'
  },
  productHeadTitle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 10
  },
  productHeadLeftTitle: {
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1
  },
  productHeadImg: {
    width: 14,
    height: 14,
    borderRadius: 7
  },
  productHeadLeftText: {
    fontSize: 12,
    lineHeight: 14,
    marginLeft: 4,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  productHeadRightText: {
    flexShrink: 1,
    fontSize: 12,
    lineHeight: 14,
    color: 'rgba(0, 0, 0, 0.54)',
    marginLeft: 12
  },
  'product-order': {
    paddingTop: 8,
    flexDirection: 'row'
  },
  'product-shop__name': {
    flexGrow: 1,
    marginRight: 12,
    flexDirection: 'row',
    alignItems: 'center'
  },
  'product-shop__name-img': {
    marginRight: 8,
    width: 17,
    height: 17
  },
  'product-shop__name-text': {
    fontSize: 14,
    lineHeight: 15,
    color: 'rgba(0, 0, 0, 0.87)',
    flex: 1
  },
  'product-order__time': {
    fontSize: 12,
    lineHeight: 14,
    color: 'rgba(0, 0, 0, 0.40)'
  },
  'product-order__status': {
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.54)'
  },
  selectFooter: {
    marginTop: 20
  },
  productStatus: {
    color: '#EE4D2D'
  },
  'product-item': {
    paddingTop: 8,
    paddingBottom: 12,
    paddingHorizontal: 0,
    paddingLeft: 84,
    position: 'relative',
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderColor: 'rgba(0, 0, 0, 0.06)'
  },
  productItem: {
    paddingTop: 0,
    paddingBottom: 12,
    paddingLeft: 80
  },
  productItemWithCount: {
    paddingBottom: 0
  },
  productItemWithoutBorder: {
    borderBottomWidth: 0
  },
  'product-item-img': {
    position: 'absolute',
    left: 0,
    top: 12,
    width: 72,
    height: 72
  },
  productItemImg: {
    top: 0,
    borderRadius: 6,
    width: 72,
    height: 72
  },
  'product-item__title': {
    fontSize: 14,
    lineHeight: 16,
    margin: 0,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  'product-item__spec': {
    marginTop: 4,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  hasQuantitySelectoProductItem: {
    marginTop: 4,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  selectorWrapper: {
    marginTop: 12,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.09)',
    alignItems: 'center'
  },
  selectorWrapperWithoutBorderBottomWidth: {
    borderBottomWidth: 0
  },
  hasQuantitySelectoProductItemText: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: 14,
    lineHeight: 16,
    flexShrink: 1
  },
  productItemSpec: {
    marginTop: 4,
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'flex-start'
  },
  productID: {
    color: 'rgba(0, 0, 0, 0.54)',
    flexShrink: 1
  },
  productStock: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginLeft: 16
  },
  'product-item__desc': {
    flexGrow: 1,
    flexShrink: 1,
    marginRight: 12,
    fontSize: 12,
    color: '#888888',
    lineHeight: 14
  },
  'product-item__amount': {
    fontSize: 12,
    color: '#888888',
    lineHeight: 14
  },
  'product-item__price': {
    margin: 0,
    marginTop: 13,
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.87)',
    textAlign: 'right'
  },
  'product-amount': {
    paddingVertical: 14,
    paddingHorizontal: 0,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderBottomColor: 'rgba(0, 0, 0, 0.06)',
    fontSize: 14,
    lineHeight: 18,
    color: '#333333',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  'product-amount__count': {
    color: '#0000008a'
  },
  'product-amount__price': {
    flexDirection: 'row'
  },
  'product-amount__price-img': {
    width: 18,
    height: 18,
    marginRight: 6
  },
  'product-amount__price-text': _objectSpread({
    color: RNStyle.brand
  }, FONT_WEIGHT_MEDIUM),
  'product-order-sn': {
    paddingVertical: 12,
    paddingHorizontal: 0,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderBottomColor: 'rgba(0, 0, 0, 0.06)',
    fontSize: 14,
    color: '#333333',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  'product-order-sn__title': {
    lineHeight: 17
  },
  'product-order-sn__content': {
    lineHeight: 16
  },
  'product-buttons': {
    paddingVertical: 0,
    paddingHorizontal: 0,
    alignItems: 'flex-end'
  },
  productButton: {
    borderRadius: 6,
    paddingVertical: 6,
    paddingHorizontal: 12
  },
  'product-button': {
    minWidth: 0,
    marginHorizontal: 0,
    marginVertical: 0,
    paddingVertical: 6,
    paddingHorizontal: 12
  },
  'product-button-text': {
    fontSize: 14,
    lineHeight: 16
  }
});